import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStudyNotes = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 12C3 5 5.00092 3 12.0005 3C19 3 21 5 21 12C21 19 18.9231 21 12.0005 21C5.07784 21 3 19 3 12Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 10H15",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 14H17",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.74965 21C7.74965 21 7.4999 16.4998 7.5 11.9999C7.5001 7.5 7.75 3 7.75 3",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgStudyNotes);
export { ForwardRef as ReactComponent };
